import {Component, ComponentFactoryResolver, ElementRef, Inject, OnDestroy, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {ActionsSubject, select, Store} from '@ngrx/store';
import * as fromSites from '../../../site/reducers';
import * as fromShippings from '../../../shipping/reducers';
import * as fromCompanies from '../../../company/reducers';
import * as fromContracts from '../../../contract/reducers';
import * as fromInvoices from '../../../invoices/reducers';
import {ActivatedRoute, convertToParamMap, Params, Router} from '@angular/router';
import * as fromRoot from '../../reducers';
import {distinctUntilChanged, filter, map, tap, withLatestFrom} from 'rxjs/operators';
import * as _ from 'lodash';
import {Observable,  Subscription} from 'rxjs';
import {OrderItem} from '../../../order/models/order-item';
import {SelectedItem} from '../../../order/models/order';
import {DataConfig} from '../../models/tabs-data';
import {PlayerFilter} from '../../../site/models/player-filter';
import {FilterDeleteIfNilService} from '../../services/filter-delete-if-nil.service';
import {MapperService} from '../../services/mapper.service';
import {CompanyDataService} from '../../../company/services/company-data.service';
import {ShippingDataService} from '../../../shipping/services/shipping-data.service';
import {ContractDataService} from '../../../contract/services/contract-data.service';
import {ShippingsContextService} from '../../../site/services/shippings-context.service';
import {SiteDataService} from '../../../site/services/site-data.service';
import {BsModalService} from 'ngx-bootstrap/modal';
import {replace, Role} from '../..';
import {InvoicesDataService} from '../../../invoices/services/invoices-data.service';
import {InvoicesService} from '../../../invoices/services/invoices.services';
import * as fromReport from '../../../report/reducers';
import {ReportDataService} from '../../../report/services/support-data.service';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';
import * as moment from 'moment';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
@Component({
  selector: 'storever-generic-datatable',
  templateUrl: './generic-datatable.component.html',
  styleUrls: ['./generic-datatable.component.scss']
})
export class GenericDatatableComponent  implements OnInit, OnDestroy {

  dataConfig: DataConfig;
  titleFragment: string;
  multiLineTooltip: string;
  checkAll: boolean;
  menuTitle: string;
  checkBockStatus: boolean;
  count$: Observable<number>;
  // tslint:disable-next-line:no-any
  filter$: Observable<any>;
  // tslint:disable-next-line:no-any
  data$: any = undefined;
  orderBy$: Observable<string>;
  page$: Observable<number>;
  pageSize$: Observable<number>;
  quickSearch$: Observable<string>;
  showFilter$: Observable<boolean>;
  selectedItem$: Observable<SelectedItem[]>;
  protected sub$: Subscription;
  protected subscriptions = [];
  private _currentClientUUID;
  roles$: Observable<Role[]>;
  menuItem = [];
  @ViewChild('dataTableComponent', {static: false}) dataTableComponent: ElementRef;
  // @ViewChild('genericDynamicComponent', { read: ViewContainerRef }) container;
  @ViewChild('genericDynamicComponent',  {static: true , read: ViewContainerRef }) container;

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale,
              protected storeSite: Store<fromSites.AppState>,
              protected storeCompany: Store<fromCompanies.AppState>,
              protected storeRoot: Store<fromRoot.AppState>,
              protected storeShipping: Store<fromShippings.AppState>,
              protected storeContract: Store<fromContracts.AppState>,
              protected storeInvoices: Store<fromInvoices.AppState>,
              protected storeReport: Store<fromReport.AppState>,
              protected activatedRoute: ActivatedRoute,
              protected router: Router,
              protected filterDeleteIfNilService: FilterDeleteIfNilService,
              protected modalService: BsModalService,
              protected companyDataService: CompanyDataService,
              private mapperService: MapperService,
              protected shippingDataService: ShippingDataService,
              protected contractDataService: ContractDataService,
              protected invoicesDataService: InvoicesDataService,
              protected siteDataService: SiteDataService,
              protected reportDataService: ReportDataService,
              protected resolver: ComponentFactoryResolver,
              protected invoicesService: InvoicesService,
              protected dispatcher: ActionsSubject,
              private sanitizer: DomSanitizer,
              protected shippingsContextService: ShippingsContextService) {
    const query$ = this.storeSite.pipe(
      select(fromRoot.selectors.getRouterState),
      filter(state => !_.isEmpty(state)),
      map(state => state.params),
      tap( (params: Params) => {
        this.checkAll = false;
        this.checkBockStatus = false;
      })
    );
    this.storeSelect();
    this.getCurrentClientUUiD();
    this.roles$ = this.storeRoot.pipe(select(fromRoot.selectors.getMyRoles));
    this.filter$ = query$.pipe(map(query => Object.assign(query)));
    this.orderBy$ = query$.pipe(map(convertToParamMap), map(query => query.get('$orderBy')));
    this.quickSearch$ = query$.pipe(map(convertToParamMap), map(query => query.get('quickSearch')));
    this.page$ = query$.pipe(map(convertToParamMap), map(query => parseInt(query.get('$page') || '1', 10)));
    if (this.selectedItem$) {
      this.sub$ = this.selectedItem$.subscribe((data: SelectedItem[]) => {
        this.checkDataLength(data);
        this.checkStatus(data);
      });
      this.subscriptions.push(this.sub$);
    }
  }

  private getCurrentClientUUiD(): void {
    this.activatedRoute.parent.params.subscribe(params => {
      if (params.clientId) {
        this._currentClientUUID = params.clientId
      }
    });
    this.multiLineTooltip = 'This is line 1<br>This is line 2<br><b>Bold line</b>';
  }
  pageChanged(page: number): void {} // used in html
  pageSizeChanged(pageSize: number): void {} // used in html
  orderByChanged(orderBy: string): void {} // used in html
  protected loadData(): void {}
  protected storeSelect(): void {}
  protected dispatchSelectPageAction(): void {}
  // tslint:disable-next-line:no-any
  applyFilter(filterForm: any): void {} // used in html
  protected dispatchClearDataAction(): void {}
  // tslint:disable-next-line:no-any
  protected toggleSelected(object: any): void {}
  // tslint:disable-next-line:no-any
  updateStoreContextualMenu(object: any): void {}
  applyQuickFilter(query: string): void {} // used in html
  toggleFilter(showFilter: boolean): void {} // used in html
  protected dispatchToggleSelected(order: OrderItem): void {}
  // tslint:disable-next-line:no-any
  routerLink(route: string, data: any, fragment?: string): {path: string[], fragment?: string | null} { return }
  disablePagination(): boolean { return }
  protected flatten(f: PlayerFilter): PlayerFilter { return }
  // tslint:disable-next-line:no-any
  actionButton(type: string, data?: any): void { return } // used in html

  ngOnInit(): void {
    window.scroll(0, 0);
  }

  loadDataOnChangeUrl(orderByGeneric: string , tableName: string ): void {
    let loadDataOnChangeUrl = true;
    const isAnomalies = this.router.url.split('?')[0].split('/')[1] === 'anomalies';
    this.sub$ = this.activatedRoute.queryParams.pipe(
      distinctUntilChanged((x, y) => _.isEqual(x, y)),
      withLatestFrom(this.storeRoot.pipe(select(fromRoot.selectors.getPreferencesByName, tableName))),
    ).subscribe(([query, length]) => {
      if (!query.$page && !loadDataOnChangeUrl && !isAnomalies) {
        query = { $page: 1, $length: length, $orderBy: orderByGeneric }; // orderBy in datatable storever still null ....
        this.storeSite.dispatch(replace([] , query, {fragment: this.titleFragment}));
      }
      else if (loadDataOnChangeUrl) {
        this.storeSite.dispatch(replace([] ,  Object.assign( {} , query ,
            {$page: 1, $length: (query.$length ? query.$length : 10), $orderBy: orderByGeneric }) ,
          {fragment: this.titleFragment} ))
        // tslint:disable-next-line:triple-equals
        if (length != query.$length ) {
          this.pageSizeChanged(query.$length ? query.$length : 10);
        }
        loadDataOnChangeUrl = false;
      }
      this.mapperService.mapQueryToFormSelect(query, this.dataConfig.form);
      if (length) {
        this.loadData();
      }

    });
    this.subscriptions.push(this.sub$);
  }

  ngOnDestroy(): void {
    if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
  }

  // tslint:disable-next-line:typedef
  invStatus(row) {

  }

  selectAll(e: boolean): void {
    this.checkAll = e;
    this.dispatchClearDataAction();
    if (e) {
      this.checkBockStatus = true;
      this.dispatchSelectPageAction();
    }
  }
  checkStatus(value: SelectedItem[]): void {}
  checkDataLength(value: SelectedItem[]): void {
    if (value.length > 0) {
      this.hideDatatableMenu(false);
    } else {
      this.hideDatatableMenu(true);
    }
  }

  private hideDatatableMenu(value: boolean): void {
    if (value) {
      this.menuTitle = '  ';
    } else {
      this.menuTitle = 'actions';
    }
  }

  get getClientUUID(): string {
    return this._currentClientUUID;
  }

  showModal($event: MouseEvent, modal: any , data: any): void {// tslint:disable-line:no-any
  }
  // tslint:disable-next-line:no-any
  // @ts-ignore
  // tslint:disable-next-line:no-any
  initMenuItem():  any[] {}
  exportAsXLSX(): void {}



  isInRole$(role: string): Observable<boolean> { return this.roles$.pipe(map(roles => _.findIndex(roles, ['code', role]) > -1)); }

  // tslint:disable-next-line:no-any
  checkActiveBillingLink(value: any): boolean {

    const current = moment(); // current date as a moment object
    const start = moment(value.startTimeLinks); // start date
    const end = value.endTimeLinks ? moment(value.endTimeLinks) : moment().add(1, 'year');

    return current.isAfter(start) && current.isBefore(end);
  }
}
